var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 17.1l-4.4-7.2c-.2-.3-.5-.5-.8-.5h-5.4c-.5 0-.9.4-.9.9v13.5h-1.3V5.9c0-.5-.4-.9-.9-.9H4.9c-.5 0-.9.4-.9.9v25.5c0 .5.4.9.9.9h1.9c.5 1.6 1.8 2.7 3.6 2.7 1.7 0 3.2-1.2 3.6-2.7h11.4c.4 1.6 1.8 2.7 3.6 2.7 1.7 0 3.2-1.2 3.6-2.7h2.9c.5 0 .9-.4.9-.9V17.6c-.2-.2-.3-.3-.3-.5zm-5.4 14.2c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8.8-1.8 1.8-1.8c.9-.1 1.8.8 1.8 1.8zm-18.4 0c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8.8-1.8 1.8-1.8c.9-.1 1.8.8 1.8 1.8zM5.8 6.8h15.8v17.1H5.8V6.8zm28.6 23.6h-2c-.4-1.6-1.8-2.8-3.6-2.8-1.7 0-3.2 1.2-3.6 2.8H14c-.4-1.6-1.8-2.8-3.6-2.8-1.7 0-3.2 1.2-3.6 2.8h-1v-4.8h28.6v4.8zm0-6.6h-8V11.3h4l4 6.5v6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 17.7c-.5 0-.9.4-.9.9s.4.9.9.9h1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-1zM13.7 8.9c-3.6 0-6.4 2.9-6.4 6.4 0 3.5 2.9 6.4 6.4 6.4 3.6 0 6.4-2.9 6.4-6.4-.1-3.5-2.9-6.4-6.4-6.4zm0 11c-2.5 0-4.6-2.1-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6 2.5 0 4.6 2.1 4.6 4.6-.1 2.6-2.1 4.6-4.6 4.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 11.4c-.5 0-.9.4-.9.9v2.1h-.5c-.5 0-.9.4-.9.9s.4.9.9.9h1.5c.5 0 .9-.4.9-.9v-2.9c-.2-.6-.6-1-1-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTime);
export default __webpack_public_path__ + "static/media/delivery-time.fc6184db.svg";
export { ForwardRef as ReactComponent };